// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 708 ? "firebase" : chunkId) + "." + {"77":"17600d23","399":"4fb13bcf","708":"f8c5080a","806":"1d70be07"}[chunkId] + ".chunk.js";
};